var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5L11 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.5C4 6.4629 6.4629 4 9.5 4C12.5371 4 15 6.4629 15 9.5C15 12.5371 12.5371 15 9.5 15C6.4629 15 4 12.5371 4 9.5ZM12.3886 8.71865C12.6475 8.49027 12.6721 8.09531 12.4438 7.83649C12.2154 7.57766 11.8204 7.55297 11.5616 7.78135L9.00416 10.0379L7.6681 8.83547C7.41153 8.60456 7.01635 8.62535 6.78544 8.88192C6.55453 9.13849 6.57533 9.53367 6.8319 9.76458L8.58194 11.3396C8.81788 11.552 9.17553 11.5537 9.41356 11.3437L12.3886 8.71865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewers);
export default __webpack_public_path__ + "static/media/reviewers.f1c280a3a6b1b0affef82409d8cc9a22.svg";
export { ForwardRef as ReactComponent };